import React, { useContext, useEffect, useState } from 'react';
import { DocumentContext } from '../../context/documentContext';
import {
  Button,
  Container,
  FormField,
  Header,
  Input,
  ProgressBar,
  SpaceBetween,
  Spinner
} from '@cloudscape-design/components';
import { kbSentenceItem } from '../../models/interfaces';
import { FreeformKnowledgebase } from './freefromKBResults';
import { BaseKeyDetail } from '@cloudscape-design/components/internal/events';

export const FreeformAnalysis = () => {
  const { freeHandleAnalyze, setFreeformeSelectedItems } =
    useContext(DocumentContext);
  const [text, setText] = useState<string>('');
  const [kbresults, setKBresults] = useState<kbSentenceItem[]>([]);
  const [kbSearching, setKBSearching] = useState<boolean>(false);
  const [progressValue, setProgressValue] = useState<number>(0);
  const [searchComplete, setSearchComplete] = useState<boolean>(false);

  // useEffect(() => {
  //   if (kbSearching) {
  //     const interval = setInterval(() => {
  //       const newValue = progressValue + 1;
  //       setProgressValue((prevValue) => {
  //         const newValue = prevValue + 1;
  //         if (newValue >= 100) {
  //           clearInterval(interval);
  //           return 100;
  //         } else {
  //           return newValue;
  //         }
  //       });
  //     }, 250);
  //     return () => clearInterval(interval);
  //   } else {
  //     setProgressValue(100);
  //   }
  // }, [kbSearching]);

  const clearAll = () => {
    setKBresults([]);
    setFreeformeSelectedItems([]);
    setText('');
  };

  // useEffect(() => {
  //   setProgressValue(100);
  // setKBSearching(false);
  // }, [kbresults]);

  const handleSearch = async () => {
    setSearchComplete(false);
    setKBresults([]);
    setKBSearching(true);
    setProgressValue(0);
    try {
      const result = await freeHandleAnalyze(text);
      setProgressValue(100);
      setTimeout(() => {
        setKBresults(result);
        setKBSearching(false);
        setSearchComplete(true);
      }, 1000);
    } catch (e) {
      setKBresults([]);
      setKBSearching(false);
      setSearchComplete(true);
    }
  };

  function handleKeyDown(event: CustomEvent<BaseKeyDetail>): void {
    console.log('event from input', event);
    if (event.detail.key === 'Enter') {
      handleSearch();
    }
  }

  return (
    <Container
      fitHeight
      header={
        <Header
          actions={
            <SpaceBetween direction="horizontal" size="s">
              <Button onClick={() => clearAll()}>Reset</Button>
              <Button onClick={() => handleSearch()}>Search</Button>
            </SpaceBetween>
          }
        >
          Search Knowledge Base
        </Header>
      }
    >
      <SpaceBetween size={'s'}>
        <FormField stretch description="Enter text" label="">
          <Input
            value={text}
            type="text"
            onChange={(event) => setText(event.detail.value)}
            onKeyDown={(event) => handleKeyDown(event)}
          />
        </FormField>
      </SpaceBetween>
      <div
        style={{
          height: '75vh',
          overflowY: 'scroll',
          width: '100%'
        }}
      >
        {kbSearching ? (
          <div
            style={{
              height: '100%',
              width: '100%',
              outline: '1px solid green',
              display: 'flex',
              flexDirection: 'column',
              alignContent: 'center',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            {/* <ProgressBar
              value={progressValue}
              additionalInfo="Additional information"
              description=""
              label="Searching Documents"
            /> */}
          <Spinner size='large' ></Spinner>
          </div>
        ) : null}

        {searchComplete ? (
          <FreeformKnowledgebase kbresults={kbresults} />
        ) : null}
      </div>
    </Container>
  );
};
